import { render, staticRenderFns } from "./MigrationErrorWindow.vue?vue&type=template&id=7c74aa52"
import script from "./MigrationErrorWindow.vue?vue&type=script&lang=js"
export * from "./MigrationErrorWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports